import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Bar, Icon } from 'Components';
import './BarNext.css';

const BarNext = props => (
  <Bar
    className={classNames({
      'bar-next--marked': props.isMarked,
    }, 'bar-next')}
    onClick={props.onClick}
  >
    <div>{props.prefix}</div>
    <div>{props.text}</div>
    <div><Icon icon="chevron_right" /></div>
  </Bar>
);

BarNext.propTypes = {
  isMarked: PropTypes.string,
  prefix: PropTypes.node,
  text: PropTypes.node,
  onClick: PropTypes.func,
};

export default BarNext;



// WEBPACK FOOTER //
// ./src/components/BarNext/BarNext.jsx